import Features from './components/Features'

export default Features
